<template>
  <div class="school-user-groups ma-0 p-3">
    <v-card>
      <v-row class="mt-2" v-if="current.user_level=='ADMIN' || current.user_level=='INCHARGE'">
        <v-col class="d-flex justify-start">
          <v-btn class="mx-3" @click="reloadUsers">
            <v-icon small>mdi-reload</v-icon>{{ $t("manage.by_school.user.user.btn_refresh") }}
          </v-btn>
          <v-btn class="ml-auto mr-3 green lighten-4" 
            v-if="current.user_level=='ADMIN'" 
            @click="dialog_add_incharge = !dialog_add_incharge">
            <v-icon left> mdi-account-plus </v-icon>
            {{ $t("manage.by_school.user.user.btn_add_incharge") }}
          </v-btn>
          
        </v-col>
      </v-row>      
      <v-data-table
        dense
        :locale="localeTranslate()"
        :search="search"
        :headers="userLabel('header')"
        :items="api.users" 
        item-key="id"
        :items-per-page="15"
        :sort-by="['acc_level']"
        :sort-desc="[false]"
        multi-sort>
        <template v-slot:top>
            <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
            ></v-text-field>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top color="red darken-1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openResetPasswordDialog(item)">
                <v-icon color="red darken-1"> mdi-lock-reset </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.user.user.btn_reset_password") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog_add_incharge" max-width="900px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_add_incharge = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.user.user.add_incharge.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row align="center">
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('school_label')"
                  v-model="resetPasswordItem.username"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('username_label')"
                  v-model="form.new_incharge_username"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('password_label')"
                  v-model="form.new_incharge_password"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('email_label')"
                  v-model="form.new_incharge_email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addInchargeAccount">
                {{ $t("manage.by_school.user.user.add_incharge.btn_create") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_add_guest_teacher" max-width="900px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeAddGuestTeacherDialog();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.user.user.add_guest_teacher.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row align="center">
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('school_label')"
                  v-model="resetPasswordItem.username"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('username_label')"
                  v-model="form.new_incharge_username"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('password_label')"
                  v-model="form.new_incharge_password"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="addInchargeLabel('email_label')"
                  v-model="form.new_incharge_email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addInchargeAccount">
                {{ $t("manage.by_school.user.user.add_incharge.btn_create") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_reset_password" max-width="600px" >
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeResetPasswordDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.user.user.reset_password.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="resetForm.username"
                  :label="resetPasswordLabel('username_label')"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :label="resetPasswordLabel('new_password_label')"
                  v-model="resetForm.new_password"
                ></v-text-field>
              </v-col>
              <!--v-col cols="12">
                <v-text-field
                  :label="resetPasswordLabel('reenter_new_password_label')"
                  v-model="resetForm.reenter_new_password"
                ></v-text-field>
              </v-col-->
            </v-row>
            <hr>
            <v-btn class="ma-4" color="success" @click="closeResetPasswordDialog()">
              {{ $t("manage.by_school.user.user.reset_password.btn.discard") }}
            </v-btn>
            <v-btn class="ma-4" color="" @click="resetUserPassword()">
              {{ $t("manage.by_school.user.user.reset_password.btn.reset") }}
            </v-btn>
            
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_import_user" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_import_user = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.user.user_group.view_group.import_user.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="api.schools"
                  item-text="school_id"
                  item-value="school_id"
                  v-model="form.school"
                  :label="importUserLabel('school_label')"
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="api.groups"
                  item-text="user_group"
                  item-value="user_group"
                  v-model="form.groups.group"
                  :label="importUserLabel('group_label')"
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  accept="text/csv"
                  :label="importUserLabel('file')"
                  :placeholder="importUserLabel('file_place_hloder')"
                  v-model="form.upload_file"
                >
                </v-file-input>
              </v-col>
              <v-col cols="12">
                <v-card class="p-1">
                  <small>{{ $t("manage.by_school.user.user_group.view_group.import_user.template_file_text") }}</small>
                  <br>
                  <div v-for="(item, i) in api.templates" :key="i">
                    <a class=" grey--text text--darken-1" :href="item.src" target="_BLANK"><v-icon class="p-1" color="grey darken-1">mdi-download</v-icon>{{ item.filename }}</a>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <hr>
            <v-btn class="ma-4" @click="batchCreateUsers">
              {{ $t("manage.by_school.user.user_group.view_group.import_user.btn_import") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { api_management } from "@/services/iot/api_management";
import { api_management_v2 } from "@/services/iot/v2/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
const apiManagementV2 = new api_management_v2(process.env.VUE_APP_BASE_URL);


export default {
  name: "experiment",
  components: {
  },
  mixins: [],
  data: function () {
    return {
      selected: [],
      dialog_add_incharge: false,      
      dialog_add_guest_teacher: false,
      dialog_import_user: false,
      dialog_reset_password: false,
      search: '',
      resetPasswordItem: {},
      headers_users: [
        { text: 'Username', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'User Group', value: 'user_group' },
        { text: 'User Level', value: 'acc_level' },
        { text: 'Create At', value: 'create_at' },
        { text: 'Last Login At', value: 'last_login_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_users_chi: [
        { text: '用戶名稱', value: 'username' },
        { text: '電郵', value: 'email' },
        { text: '組別', value: 'user_group' },
        { text: '權限等級', value: 'acc_level' },
        { text: '創建於', value: 'create_at' },
        { text: '最後更新', value: 'last_login_at' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      api:{
        schools: [],
        users: [],
      },
      //
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      activeDialog: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        new_group: "",
        host: "HOST",
        group: "",
        upload_file: null,
        groups:{
          group: "",
          host: "",
        },
        new_incharge_username: "",
        new_incharge_password: "",
        new_incharge_email: ""
      },
      resetForm: {
        username: "",
        new_password: "",
        reenter_new_password: "",
      }
      ,
      title_breadcrumbs: [{ text: 'Title'},],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;    
    self.current.auth_token = self.$store.state.user.auth_token;
    self.api.schools = [self.current.school_id];

    self.form.school = self.current.school_id;
    self.getUsersBySchool();
    
    self.title_breadcrumbs = [
      { text: 'School: ' + self.current.school_id },
    ];
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    isValid: function(){
      var self = this;
      if(self.form.new_incharge_username.trim()==""){
        alert("Missing incharge account username");
        return false;
      }
      if(self.form.new_incharge_password.trim()==""){
        alert("Missing incharge account password");
        return false;
      }
      return true;
    },
    isValidGuestTeacher: function(){
      var self = this;
      if(self.form.new_incharge_username.trim()==""){
        alert("Missing incharge account username");
        return false;
      }
      if(self.form.new_incharge_password.trim()==""){
        alert("Missing incharge account password");
        return false;
      }
      return true;
    },
    userLabel(label){
      var self = this;
      if(self.$i18n.locale == 'tc'){
        if(label=='header') return self.headers_users_chi;
        else if(label=='ungroup') return self.$t("manage.by_school.user.user_group.view_group.btn_ungroup");
      }
      else {
        if(label=='header') return self.headers_users;
        else if(label=='ungroup') return self.$t("manage.by_school.user.user_group.view_group.btn_ungroup");
      }
    },
    addInchargeLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='username_label') return self.$t("manage.by_school.user.user.add_incharge.username");
        else if (label=='password_label') return self.$t("manage.by_school.user.user.add_incharge.password");
        else if (label=='email_label') return self.$t("manage.by_school.user.user.add_incharge.email");
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='username_label') return self.$t("manage.by_school.user.user.add_incharge.username");
        else if (label=='password_label') return self.$t("manage.by_school.user.user.add_incharge.password");
        else if (label=='email_label') return self.$t("manage.by_school.user.user.add_incharge.email");
      }
    },    
    resetPasswordLabel(label){
      var self = this;
      if (label=='username_label') return self.$t("manage.by_school.user.user.reset_password.username");
      else if (label=='new_password_label') return self.$t("manage.by_school.user.user.reset_password.new_password");
      else if (label=='reenter_new_password_label') return self.$t("manage.by_school.user.user.reset_password.reenter_new_password");
    },
    openResetPasswordDialog(item){
      var self = this;
      self.resetPasswordItem = item;      
      self.dialog_reset_password = true;
      self.resetForm.username = item.username;
    },
    closeResetPasswordDialog(){
      var self = this;
      self.dialog_reset_password = false;
      self.resetForm.username = "";
      self.resetForm.new_password = "";
      self.resetForm.reenter_new_password = "";
      self.resetPasswordItem = {};
    },
    reloadUsers(){
      var self = this;
      self.getUsersBySchool();
    },
    getUsersBySchool(){
      var self = this;
      apiManagement.getUsersBySchool(self.current.school_id)
      .then((response) => {
          self.api.users = response.users;
      });
    },
    addInchargeAccount(){
      var self = this;
      if(self.isValid()){
        apiManagement.addInchargeAccount(self.current.school_id, self.form.new_incharge_username, self.form.new_incharge_password, self.form.new_incharge_email, self.current.username, self.current.auth_token)
        .then((response) =>{
          if(response.status=="success"){
            self.$store.commit("showSnackBar", "New Incharge account has been created.");
            self.dialog_add_incharge = !self.dialog_add_incharge;
            self.form.new_incharge_email = "";
            self.form.new_incharge_password = "";
            self.form.new_incharge_username = "";
            self.form.new_school_id = "";
            self.getUsersBySchool();
          }
          else if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.message);
          }
        });
      }
    },
    addGuestTeacherAccount(){
      var self = this;
      if(self.isValidGuestTeacher()){
        let active = "ACTIVE";
        apiManagement.getUsersBySchool(self.current.school_id, active, self.current.user_level)
        .then((response) => {
          console.log(response.groups);
            //self.api.users = response.users;
        });
      }
    },
    resetUserPassword(){
      var self = this;
      apiManagement.resetUserPassword(self.current.school_id, self.resetForm.username, self.resetForm.new_password).then((response) =>{
          if(response.status=="success"){
            self.$store.commit("showSnackBar", "User Password has been reset.");
            self.dialog_reset_password = !self.dialog_reset_password;
            self.resetForm.reenter_new_password = "";
            self.resetForm.new_password = "";
            self.resetForm.username = "";
            self.getUsersBySchool();
          }
          else if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.message);
          }
        });
    },
    openAddGuestTeacherDialog(){
      var self = this;
      self.dialog_add_guest_teacher = true;
      var self = this;
      let active = "ACTIVE";
      apiManagement.getSchoolUserGroupsGuest(self.current.school_id, active, self.current.user_level)
      .then((response) => {
        console.log(response.groups);
          //self.api.users = response.users;
      });
    },
    closeAddGuestTeacherDialog(){
      var self = this;
      self.dialog_add_guest_teacher = false;
      
    },
    openCreateUserDialog(){
      var self = this;
      self.dialog_import_user = true;
      self.getImportUserTemplate();
    },
    importUserLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='group_label') return self.$t("manage.by_school.user.user_group.group");
        else if (label=='file') return "新檔案"
        else if (label=='file_place_hloder') return "選擇CSV格式的檔案"
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='group_label') return self.$t("manage.by_school.user.user_group.group");
        else if (label=='file') return "New File Input"
        else if (label=='file_place_hloder') return "Select file in CSV format"
      }
    },
    
    getImportUserTemplate(){
      var self = this;
      apiManagement.getImportUserTemplate()
      .then((response) => {
        if(response.status == "success"){
          self.api.templates = response.templates;
        }
      });
    },
    batchCreateUsers(){
      var self = this;
      apiManagementV2.batchCreateUsers(self.current.school_id, self.form.upload_file)
      .then((response) => {
        console.log(response);
/*
        if(response.status == "success"){
          if(response.error!=''){
            self.$store.commit("showSnackBar", "Some user is not added. Please make sure the file is in correct CSV format.");
            self.viewUserGroup(self.usersItem);
          }
          else {
            self.$store.commit("showSnackBar", "Added New User Group");
            self.dialog_import_user = !self.dialog_import_user;
            
          }
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", response.message);
        }
        else {
          self.$store.commit("showSnackBar", "Error, please try again.");
        }
        */
      });
    },
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      if(self.$route.name == 'admin-school-management'){
        self.$router.push("/admin/management/school/school_list");
      }
      else {
        self.$router.push("/school/school_list");
      }
    },
  },
  destroyed(){
    clearInterval(this.kick_inte);
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>